<template>
  <section class="dispenser-dashboard-index">
    <Breadcrumbs
      :breadcrumbs="[
        {title: this.$t(`menu.${this.serviceSlug}`), disabled: true},
        {title: this.$t(`virtual_waiting_room.pages.dispenser_dashboard`)}
      ]">
    </Breadcrumbs>

    <br/>
    <div class="active-request" >
      <h2>{{ this.$t('virtual_waiting_room.titles.request') }}</h2>
      <div class="d-flex justify--start pl-4 mt-4" >
        <div class="request_base" v-bind:class="{'active': activeState, 'waiting-online-audiologists': !hasOnlineUsers}">
          <div v-if="!hasActiveRequest" class="no_request" >
            <h5 > {{ $t('virtual_waiting_room.requests.no_active_request') }}</h5>
          </div>
          <div v-if="hasActiveRequest" class="request"  >
            <div class="left_wrapper">
              <div class="row " v-bind:class="{'ml-3': hasOnlineUsers, 'ml-0': !hasOnlineUsers}">
                <div v-if="!hasOnlineUsers" class="row">
                  <div class="col-2">
                    <i class="i-waiting-user mt-3 mr-4"/>
                  </div>
                  <div class="col-10">
                    <h5 class="is-bold on-hold-title">
                      {{$t('virtual_waiting_room.dispenser_dashboard.on_hold')}}
                    </h5>
                    <span>
                    {{$t('virtual_waiting_room.dispenser_dashboard.waiting_online_users')}}
                  </span>
                    <br/>
                    <span>
                    {{$t('virtual_waiting_room.dispenser_dashboard.request_for_c_number_on_hold', {c_number: activeRequest.customerNumber})}}
                  </span>
                  </div>

                </div>
                <div v-if="hasOnlineUsers" class="w-100">
                  <div>
                    <span v-if="activeRequest.acceptedBy === null" class="is-bold text-success">
                      {{ $t('clinical.appointments.waiting_for_call_for') }}
                    </span>
                    <span v-if="activeRequest.acceptedBy !== null">{{ $t('clinical.appointments.in_call_with') | upperCase }}</span>
                    &nbsp;
                    <span class="is-bold text-success" v-if="activeRequest && activeRequest.customerNumber">
                      {{ activeRequest.customerNumber }}
                    </span>
                  </div>
                  <div v-if="activeRequestDailyRequestNr != null" class="mt-1">
                    <span class="is-bold text-success">
                      {{ $t('virtual_waiting_room.dispenser_dashboard.request_number', { nr: activeRequestDailyRequestNr }) }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row d-flex flex-column justify--center" v-if="activeRequest.acceptedBy === null">
                <div v-if="hasOnlineUsers">
                  <div>
                    <small class="text-success">{{ $t('clinical.appointments.waiting_for_call_time_remaining') }}:</small>
                  </div>
                  <div v-if="activeRequest.estimatedAcceptTime === null" class="estimated-waiting-time time-unit-separator">
                  <span class="is-bold">
                    N/A
                  </span>
                  </div>
                  <div v-else>
                    <div class="estimated-waiting-time d-flex"
                         v-if="estimatedTimeUntilAcceptance !== null && estimatedTimeToAcceptance !== null && estimatedTimeToAcceptance.minutes() >= 1">
                      <div class="d-flex flex-column align-items-center" v-if="estimatedTimeToAcceptance.hours() > 0">
                        <span class="time-unit is-bold">{{ withLeadingZero(estimatedTimeToAcceptance.hours()) }}</span>
                        <small class="time-unit-desc">{{ $t('time.hours') }}</small>
                      </div>

                      <span class="time-unit-separator mx-1" v-if="estimatedTimeToAcceptance.hours() > 0">:</span>

                      <div class="d-flex flex-column align-items-center">
                        <span class="time-unit is-bold">{{ withLeadingZero(estimatedTimeToAcceptance.minutes()) }}</span>
                        <small class="time-unit-desc">{{ $t('time.min') }}</small>
                      </div>

                      <span class="time-unit-separator mx-1">:</span>

                      <div class="d-flex flex-column align-items-center">
                        <span class="time-unit is-bold">{{ withLeadingZero(estimatedTimeToAcceptance.seconds()) }}</span>
                        <small class="time-unit-desc">{{ $t('time.sec') }}</small>
                      </div>
                    </div>
                    <div v-else class="estimated-waiting-time time-unit-separator">
                  <span class="is-bold">
                    {{ $t('clinical.appointments.call_in_a_few_moments') }}...
                  </span>
                    </div>
                  </div>
                </div>


              </div>

              <div class="row d-flex flex-column justify--center" v-if="activeRequest.acceptedBy !== null">
                <div class="call-duration" v-if="callDuration !== null">
                  <span>{{ getDurationString(callDuration.asSeconds(), 'seconds', true, ' : ', false) }}</span>
                </div>
              </div>

            </div>


            <div class="right_wrapper">
              <va-popover
                v-if="canCancelRequest"
                placement="top"
                :message="$t('clinical.appointments.cancel_call')"
              >
                <va-button
                  id="btn-cancel"
                  large
                  class="va-button-rounded"
                  icon="fa fa-phone"
                  @click="onClickCancel"
                >
                </va-button>
              </va-popover>

              <va-popover
                v-if="activeState"
                placement="top"
                :message="$t('clinical.appointments.dismiss_call')"
              >
                <va-button
                  id="btn-dismiss"
                  large
                  class="va-button-rounded"
                  icon="fa fa-phone"
                  @click="onClickEndCall"
                >
                </va-button>
              </va-popover>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="statistics mt-5">
      <h2>{{ this.$t('virtual_waiting_room.titles.dispenser_statistics') }}</h2>

      <DispenserStatistics
        class="mt-4"
        :service-slug="serviceSlug"
        :component="component"
        :isChildComponent="true"
      />
    </div>
    <CancelCallRequestModal
      v-if="hasActiveRequest && isCancelingPendingRequest"
      :request="activeRequest"
      @requestCanceled="onRequestCanceled"
      @operation-not-permited="onRequestCancelOperationNotPermited"
      @modalClosed="onCancelPendingRequestModalClosed"
    />
    <ConfirmationModal
      v-if="showEndConfirmationModal"
      :title="undefined"
      :body="this.$t('clinical.people.appointments.end_call_confirmation_message')"
      @modal-confirmed="endCallModalConfirm"
      @modal-canceled="endCallModalCanceled"
    />
  </section>
</template>
<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import DispenserStatistics from '../statistics/dispensers/index'
import CancelCallRequestModal from "@/components/virtual_waiting_room/dispenser_dashboard/CancelCallRequestModal";
import SocketioService from "@/services/socketio.service";
import * as _ from "lodash";
import {mapGetters, mapState} from "vuex";
import RelativeTimeMixin from "@/mixins/RelativeTimeMixin";
import ConfirmationModal from "@/components/common/ConfirmationModal";
import {RequestService} from "@/api/VirtualWaitingRoomService";
import EventBus from "@/utils/EventBus";

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    },
  },
  mixins: [RelativeTimeMixin],
  components: {
    ConfirmationModal,
    Breadcrumbs,
    DispenserStatistics,
    CancelCallRequestModal
  },
  created() {
    SocketioService.getActiveRequest()
    EventBus.$on('modalClosed', () => {
      this.onCancelPendingRequestModalClosed()
    })
  },
  data() {
    return {
      isCancelingPendingRequest: false,
      estimatedTimeToAcceptance: null,
      estimatedTimeTicker: null,
      callDuration: null,
      callDurationTicker: null,
      hasStartedCountingTime: false,
      showEndConfirmationModal: false,
    }
  },
  methods: {
    onClickCancel: function () {
      this.isCancelingPendingRequest = true
    },
    onClickEndCall: function () {
      this.showEndConfirmationModal = true
    },
    endCallModalConfirm: function () {
      if (this.hasActiveRequest) {
        const request = this.activeRequest
        RequestService.end(request.id, 'dispenser')
          .then(() => {
            this.showEndConfirmationModal = false
            this.$store.commit(`${this.waitingRoomModuleKey}/RESET_ACTIVE_REQUEST`)
          })
          .catch(() => {
            this.showToast(this.$t('clinical.appointments.end_call_request_failed'), this.$store.state.errorToastOptions)
          })
      }
    },
    endCallModalCanceled: function () {
      this.showEndConfirmationModal = false
    },
    onRequestCanceled: function () {
      //this.request = null
      this.isCancelingPendingRequest = false
    },
    onRequestCancelOperationNotPermited: function () {

    },
    onCancelPendingRequestModalClosed: function () {
      this.isCancelingPendingRequest = false
    },
    updateEstimatedTimeToAcceptance: function () {
      if (this.estimatedTimeUntilAcceptance !== null) {
        this.estimatedTimeToAcceptance = this.moment.duration(this.estimatedTimeUntilAcceptance.diff(this.moment()))
      }
    },
    clearEstimatedTimeVariables: function () {
      if (this.estimatedTimeTicker !== null) {
        clearInterval(this.estimatedTimeTicker)
        this.estimatedTimeTicker = null
        this.estimatedTimeToAcceptance = null
      }
    },
    updateCallDuration: function () {
      this.callDuration = this.moment.duration(this.moment().diff(this.activeRequest.startedAt))
      if (this.activeRequest) {
        this.secondsRemainToEnd = this.activeRequest.estimatedDuration * 60 - this.callDuration.asSeconds()
        this.isNearEnd = this.activeRequest.estimatedDuration * 60 - this.callDuration.asSeconds() < 600
        if (!this.hasStartedCountingTime && this.secondsRemainToEnd > 1) {
          this.hasStartedCountingTime = true
        }
      }
    },
    clearCallDurationVariables: function () {
      if (this.callDurationTicker !== null) {
        clearInterval(this.callDurationTicker)
        this.callDurationTicker = null
        this.callDuration = null
      }
    },
  },
  computed: {
    waitingRoomModuleKey: function () {
      return `virtualWaitingRoom`
    },
    ...mapGetters({
      userIsActiveAudiologist: 'auth/userIsActiveAudiologist'
    }),
    ...mapState({
      activeRequest(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/activeRequest`] || null
      },
      onlineAudiologists(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/onlineAudiologists`] || null
      },
    }),
    hasOnlineUsers: function () {
      return !!(this.onlineAudiologists !== null && this.onlineAudiologists.online && this.onlineAudiologists.online - this.onlineAudiologists.inBreak > 0)
    },
    estimatedTimeUntilAcceptance: function () {
      let estimatedTimeToAcceptance = _.get(this.activeRequest, 'estimatedAcceptTime')
      return estimatedTimeToAcceptance !== null ? this.moment(estimatedTimeToAcceptance) : null
    },
    hasActiveRequest: function () {
      const request = this.activeRequest
      if (!request) {
        return false
      }
      const dispenserEndedAt = request.dispenserEndedAt != null
        ? request.dispenserEndedAt
        : request.dispenser_ended_at
      return dispenserEndedAt == null
    },
    activeRequestDailyRequestNr: function () {
      if (!this.activeRequest) {
        return null
      }
      return this.activeRequest.dailyRequestNr != null
        ? this.activeRequest.dailyRequestNr
        : this.activeRequest.daily_request_nr
    },
    callHasBeenAccepted: function () {
      const request = this.activeRequest
      if (!request) {
        return false
      }
      const startedAt = request.startedAt != null ? request.startedAt : request.started_at
      return startedAt != null
    },
    canCancelRequest: function () {
      return this.hasActiveRequest && !this.callHasBeenAccepted
    },
    callHasEnded: function () {
      const request = this.activeRequest
      if (!request) {
        return false
      }
      const dispenserEndedAt = request.dispenserEndedAt != null
        ? request.dispenserEndedAt
        : request.dispenser_ended_at
      return dispenserEndedAt != null
    },
    activeState: function () {
      return this.hasActiveRequest && this.callHasBeenAccepted && !this.callHasEnded
    },
  },
  watch: {
    activeRequest: {
      handler: function () {
        if (this.activeRequest && !this.hasActiveRequest) {
          this.$store.commit(`${this.waitingRoomModuleKey}/RESET_ACTIVE_REQUEST`)
        }
      },
      immediate: true
    },
    estimatedTimeUntilAcceptance: {
      handler: function (value) {
        if (value !== null) {
          if (this.estimatedTimeTicker === null) {
            this.estimatedTimeTicker = setInterval(this.updateEstimatedTimeToAcceptance, 1000)
          }
        } else {
          this.clearEstimatedTimeVariables()
        }
      },
      immediate: true
    },
    callHasBeenAccepted: {
      handler: function (value) {
        if (value) {
          if (this.callDurationTicker === null) {
            this.callDurationTicker = setInterval(this.updateCallDuration, 1000)
          }
        } else {
          this.clearCallDurationVariables()
        }
      },
      immediate: true
    },
  }

}
</script>
<style lang="scss">
.waiting-online-audiologists {
  background-color: #F6C242 !important;

  h5 {
    color: #6E6E6E;
  }
}

.request_base {
  background-color: #eeeeee;
  width: 50%;
  height: 120px;
  border-radius: 20px;
  border-color: #a2a2a2;
  border-width: 2px;
  -moz-box-shadow: 0px 3px 5px 6px rgba(190, 190, 190, .7);;
  -webkit-box-shadow: 0px 3px 5px 6px rgba(190, 190, 190, .7);;
  box-shadow: 0px 3px 5px 6px rgba(190, 190, 190, .7);
  display: flex;
}

.no_request {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.request {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-left: 10px;
}

.left_wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: 10px;
  width: 70%;
  height: 100%;
}

.right_wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 30%;
  margin-left: 10px;
}

.dark_label {
  color: #a2a2a2
}

.kpi-card {
  margin-left: 0px !important;
}


#btn-cancel {
  width: 3rem;
  height: 3rem;
  border-radius: 2rem;
  background-color: #c5253a !important;

  .va-icon.fa-phone {
    transform: rotate(135deg) !important;
  }
}

.active {
  background-color: #414141;
  color: white;
}

#btn-dismiss {
  width: 4rem;
  height: 4rem;
  border-radius: 2rem;
  background-color: #c5253a !important;

  .va-icon.fa-phone {
    transform: rotate(135deg) !important;
  }
}



</style>
